import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useMeasurementWizardStore } from '@/store/useMeasurementWizardStore';

interface TestCard {
  name: string;
  color: string;
  colorHex: string;
  icon: string;
}

const HARDCODED_TESTS: TestCard[] = [
  { name: 'Flu A', color: 'Channel 1', colorHex: '#a3a3a3', icon: '' },
  { name: 'Flu B', color: 'Channel 2', colorHex: '#a3a3a3', icon: '' },
  { name: 'RSV', color: 'Channel 3', colorHex: '#a3a3a3', icon: '' },
  { name: 'COVID-19', color: 'Channel 4', colorHex: '#a3a3a3', icon: '' },
];

/**
 * Step 1: Test Panel Information
 * 
 * Display hardcoded 4-channel test panel (Flu A, Flu B, RSV, COVID-19).
 * This is informational only - no user selection required.
 */
export function Step1TestPanel() {
  const setCurrentStep = useMeasurementWizardStore((s) => s.setCurrentStep);

  const handleProceed = () => {
    setCurrentStep(2);
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', py: 0 }}>
      <Typography variant="h5" gutterBottom align="center">
        Upper Respiratory Infection Panel
      </Typography>
      
      <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 4 }}>
        This test measures the following pathogens:
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 4 }}>
        {HARDCODED_TESTS.map((test) => (
          <Card key={test.name} variant="outlined">
            <CardContent>
              <Box display="flex" alignItems="center" gap={2}>
                <Typography 
                  fontSize="2rem"
                  sx={{ 
                    filter: `drop-shadow(0 0 8px ${test.colorHex})`,
                    color: test.colorHex,
                  }}
                >
                  {test.icon}
                </Typography>
                <Box>
                  <Typography variant="body1" fontWeight="medium">
                    {test.name}
                  </Typography>
                  <Typography 
                    variant="caption" 
                    sx={{ color: test.colorHex, fontWeight: 500 }}
                  >
                    {test.color} indicator
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>

      <Button
        variant="contained"
        size="large"
        fullWidth
        onClick={handleProceed}
      >
        Proceed
      </Button>
    </Box>
  );
}
